import { BookingPageNotFound } from '@/features/entry'

/** Any other path, or a malformed slug (Frontend §4.1): "This booking page doesn't exist". */
export function NotFoundPage() {
  return (
    <div className="pt">
      <main className="pt-main">
        <BookingPageNotFound />
      </main>
    </div>
  )
}
